import { isInvoiced as isLegacySubscriptionInvoiced } from '../internal/legacySubscription/isInvoiced';
import { isInvoiced as isModernSubscriptionInvoiced } from '../internal/modernSubscription/isInvoiced';
import type { Subscription } from '../types';

import { isModernSubscription } from './isModernSubscription';

export function isInvoiced(subscription: Subscription) {
  if (isModernSubscription(subscription)) {
    return isModernSubscriptionInvoiced(subscription);
  }

  return isLegacySubscriptionInvoiced(subscription);
}
